// import components
import {
  showErrorSnackbar,
  showSuccessSnackbar
} from '../components/shared/Snackbar';

// import external libraries
import axios, { AxiosError } from 'axios';
import { useMutation, useQueryClient } from 'react-query';

// import types
import { GridRowId } from '@mui/x-data-grid-pro';
import { QueryKey } from 'react-query/types/core/types';
import { DeleteErrorResponse } from './useDeleteById.types';

export const useDeleteById = (
  url?: string,
  invalidateQueryKey?: QueryKey,
  options: { showSuccessSnackbar: boolean; showErrorSnackbar: boolean } = {
    showSuccessSnackbar: true,
    showErrorSnackbar: true
  }
) => {
  const queryClient = useQueryClient();

  return useMutation<any, any, any>(
    (id: GridRowId[]) => axios.delete(`${url}/${id}`),
    {
      onSuccess: async () => {
        if (invalidateQueryKey)
          await queryClient.invalidateQueries(invalidateQueryKey);
        if (options.showSuccessSnackbar) showSuccessSnackbar();
      },
      onError: (err: AxiosError<DeleteErrorResponse>) => {
        if (options.showErrorSnackbar)
          showErrorSnackbar(err.response?.data?.error?.message);
      }
    }
  );
};
